import DoughnutChart from "./DoughnutChart";

export default DoughnutChart;
